interface TopicItem {
  name: string;
  heat: string;
  count: string;
  color: string;
}

const topics: TopicItem[] = [
  { name: '顶流恋情曝光', heat: '🔥🔥🔥🔥🔥', count: '128 万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '综艺翻车现场', heat: '🔥🔥🔥🔥', count: '96 万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '网红塌房实录', heat: '🔥🔥🔥🔥🔥', count: '215 万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '娱乐圈税务风暴', heat: '🔥🔥🔥🔥', count: '87 万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '选秀黑幕曝光', heat: '🔥🔥🔥', count: '63 万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '明星夫妻分居', heat: '🔥🔥🔥🔥', count: '102 万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '大制作电影事故', heat: '🔥🔥🔥', count: '54 万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '主持人耍大牌', heat: '🔥🔥🔥🔥', count: '78 万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { name: '游戏主播外挂门', heat: '🔥🔥🔥🔥🔥', count: '189 万讨论', color: 'bg-accent-100 text-accent-700' },
  { name: '品牌代言翻车', heat: '🔥🔥🔥', count: '45 万讨论', color: 'bg-primary-100 text-primary-700' },
  { name: '晚会假唱风波', heat: '🔥🔥🔥🔥', count: '91 万讨论', color: 'bg-secondary-100 text-secondary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">
            今日热议的吃瓜话题，点击看看大家都在讨论什么
          </p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="flex items-center gap-3 px-4 py-3 rounded-xl border border-background-200/70 bg-background-50 hover:border-accent-300/60 transition-colors cursor-pointer"
            >
              <span className={`text-xs font-semibold px-2.5 py-0.5 rounded-full whitespace-nowrap ${topic.color}`}>
                {topic.name}
              </span>
              <div className="flex items-center gap-2 text-xs text-foreground-400">
                <span className="whitespace-nowrap">{topic.heat}</span>
                <span className="w-px h-3 bg-background-300/60"></span>
                <span className="whitespace-nowrap">{topic.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}